// components
import maDamageItemCamera from './../damageItemCamera'
import maDamageItemPhotoclaim from './../damageItemPhotoclaim'
import maInputSurface from '@/components/input/modules/text'
import maButtonWhite from '@/components/button-blue'
import maCameraComponent from '@/components/cameraComponent'
import userFlowMixin from '@/modules/User/mixins/userFlowMixin'

// import event Bus
import maEventBus from '@/components/eventbus/index.js'

export default {
  mame: 'damagedPartCamera',
  mixins: [userFlowMixin],

  data() {
    return {
      showDeleteBtn: false,
      cameraBtn: true
    }
  },

  props: {
    damagedPart: {
      type: Object,
      required: true
    },
    buttonEnable: {
      type: Boolean,
      default: true
    },
    photosTaken: {
      type: Boolean,
      default: false
    }
  },

  components: {
    maDamageItemCamera,
    maInputSurface,
    maButtonWhite,
    maCameraComponent,
    maDamageItemPhotoclaim
  },
  computed: {
    flowName() {
      return this.getUserFlow
    }
  },

  methods: {
    handleMoreOptions() {
      this.showDeleteBtn = !this.showDeleteBtn
    },
    handleOnShowModalCamera() {
      this.$emit('openModalCamera', this.damagedPart)
    },
    handleAddMoreDamage() {
      this.$emit('openCameraForm', this.damagedPart)
    },
    handleNoPhotosRequired() {
      this.$emit('openCameraForm', this.damagedPart)
    },
    showCameraBtn() {
      if (
        (Object.keys(this.$refs).length != 0 ||
          this.flowName == 'photoclaim' ||
          this.damagedPart.partDamages != undefined) &&
        this.damagedPart.partDamages.length !== 0
      ) {
        this.cameraBtn = false
      } else {
        this.cameraBtn = true
      }
    }
  },
  mounted() {
    this.showCameraBtn()
    maEventBus.$on('btnDelete:clicked', () => {
      this.showDeleteBtn = false
    })
  }
}
